import React from "react";

const Privacy = () => {
  return (
    <div className=" flex justify-center">
      <div className=" flex flex-col gap-6  md:py-20  pt-16 md:w-10/12  w-full md:px-0 px-4">
        <div className=" flex flex-col gap-1">
          <h1 className=" md:text-4xl text-2x font-bold text-black">PRIVACY POLICY</h1>
          <h1>
            This Privacy Policy is made for both parties (We) and (Our Visitors)
            to understand, follow and maintain the boundaries of the service
            provider – service receiver relationship. This Privacy Policy
            governs the manner in which Brocade Nepal collects, uses, maintains,
            and discloses information collected from users each, a User of the
            Brocadenepal.com website Site. This privacy policy applies to the
            Site and all products and services offered by Brocade Nepal.
          </h1>
        </div>
        <div className=" flex flex-col gap-1 ">
          <h1 className=" md:font-normal md:text-3xl text-xl font-bold text-black">Visitors Consent</h1>
          <h1>
            By visiting our website, you agree to consent to our Privacy Policy
            and Agree to Its Terms as Mentioned.
          </h1>
        </div>
        <div className=" flex flex-col gap-1">
          <h1 className=" md:font-normal md:text-3xl text-xl font-bold text-black">We Only Collect Information You Willingly Provide</h1>
          <h1>
            We only collect your personal information only when it is necessary
            for certain services you wish to receive. There will be no personal
            data collected without the visitor’s permission.
          </h1>
        </div>
        <div className=" flex flex-col gap-1">
          <h1 className=" md:font-normal md:text-3xl text-xl font-bold text-black">Personal identification information</h1>
          <h2>
            We may collect personal identification information from Users in a
            variety of ways, including, but not limited to, when Users visit our
            site, register on the site, place an order, subscribe to the
            newsletter, respond to a survey, fill out a form, and in connection
            with other activities, services, features or resources we make
            available on our Site. Users may be asked for, as appropriate, name,
            email address, credit card information. Users may, however, visit
            our Site anonymously. We will collect personal identification
            information from Users only if they voluntarily submit such
            information to us. Users can always refuse to supply personally
            identification information, except that it may prevent them from
            engaging in certain Site related activities. Brocade Nepal does not
            intentionally collect information from children under the age of
            thirteen (13).
          </h2>
        </div>
        <div className="flex flex-col gap-1">
          <h1 className=" md:font-normal md:text-3xl text-xl font-bold text-black">
            Non-personal identification informationPersonal identification
            information
          </h1>
          <h2>
            We may collect non-personal identification information about Users
            whenever they interact with our Site. Non-personal identification
            information may include the bser name, the type of computer, and
            technical information about Users means of connection to our Site,
            such as the operating system and the Internet service providers
            utilized and other similar information.
          </h2>
        </div>
        <div className="flex flex-col gap-1">
          <h1 className= " md:font-normal md:text-3xl text-xl font-bold text-black"> Web bser cookies</h1>
          <h2>
            Our Site may use cookies to enhance the User experience. Users web
            bser places cookies on their hard drive for record-keeping purposes
            and sometimes to track information about them. Users may choose to
            set their web bser to refuse cookies or to alert you when cookies
            are being sent. If they do so, note that some parts of the Site may
            not function properly.
          </h2>
        </div>
        <div className="flex flex-col gap-1">
          <h1 className=" md:font-normal md:text-3xl text-xl font-bold text-black">How we use collected information</h1>
          <h2>
            Brocade Nepal may collect and use Users personal information for the
            following purposes: To Communicate with You Directly or Through One
            of Our Partners Whose Services You Wish to Use To Send You Emails
            for various Purposes Like Product Description and Communication For
            Marketing Purpose of Our Products and Services Analysis of Your
            Behavior While You Visit Our Site For Operation and Maintenance of
            Our Website To Improve the User Interface of Our Website Develop new
            products, services, features, and functionality To Find and Prevent
            Fraudulent Activities How we protect your information We adopt
            appropriate data collection, storage, and processing practices and
            security measures to protect against unauthorized access,
            alteration, disclosure, or destruction of your personal information,
            username, password, information, and data stored on our
            Site. Sensitive and private data exchange between the Site and its
            Users happens over an SSL secured communication channel and is
            encrypted and protected with digital signatures. Brocade Nepal uses
            the services of third-party vendors for storage, network, and
            technical services. Personally, identifying information may be
            transferred outside of your home country as part of our provision of
            services to you. When required by law (under governmental order,
            warrant, or subpoena), or when Brocade Nepal believes that
            disclosure is reasonably necessary to protect the rights of Brocade
            Nepal or third parties, personally identifying information may be
            disclosed. Brocade Nepal reserves to right to publish correspondence
            and feedback sent to us in order to help us respond to the
            correspondence or to help other users. Should Brocade Nepal be
            acquired or merged with another organization, your information may
            be transferred. We will notify you if your information is to be
            subject to a different privacy policy. Should Brocade Nepal cease
            trading or file for bankruptcy, information held about you will not
            be transferred to a third party.
          </h2>
        </div>
        <div className="flex flex-col gap-1">
          <h1 className=" md:font-normal md:text-3xl text-xl font-bold text-black">Sharing your personal information</h1>
          <h2>
            We do not sell, trade, or rent Users personal identification
            information to others. We may share generic aggregated demographic
            information not linked to any personal identification information
            regarding visitors and users with our business partners, trusted
            affiliates, and advertisers for the purposes outlined above.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
